'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  ['\n  text-align: center;\n'],
  ['\n  text-align: center;\n']
)

var _Flex = require('./Flex')

var _Flex2 = _interopRequireDefault(_Flex)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Section = _Flex2.default.withComponent('section').extend(_templateObject)

Section.displayName = 'Section'

Section.defaultProps = {
  theme: _theme2.default,
  align: 'center',
  justify: 'center',
  flexDirection: 'column',
  color: 'white',
  py: [4, 5],
  px: 3
}

exports.default = Section



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Section.js
// module id = 521
// module chunks = 168707334958949